import { render, staticRenderFns } from "./bx-text.vue?vue&type=template&id=86444280"
import script from "./bx-text.vue?vue&type=script&lang=js"
export * from "./bx-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports